import { esES } from '@mui/material/locale';
import { createTheme as createMuiTheme, responsiveFontSizes } from '@mui/material/styles';
import { esES as pickersEsES } from '@mui/x-date-pickers';
import { baseThemeOptions } from './base-theme-options';
import { darkThemeOptions } from './dark-theme-options';
import { lightThemeOptions } from './light-theme-options';

// Esto tiene que venir del JSON, usar para desarrollo.

// const debugTotemTheme = {
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           boxShadow: 0,
//         },
//       },
//       variants: [
//         {
//           props: { variant: 'btn-totem' },
//           style: {
//             color: 'white',
//             // boxShadow: 'none',
//             textTransform: 'none',
//             fontSize: '60px',
//             padding: '6px 12px',
//             border: '1px solid',
//             lineHeight: 1.5,
//             backgroundColor: '#ED1C24',
//             borderColor: '#ED1C24',
//             minWidth: 400,
//             minHeight: 180,
//             '&:hover': { backgroundColor: '#ED1C24' },
//           },
//         },
//         {
//           props: { variant: 'btn-back' },
//           style: {
//             color: 'white',
//             boxShadow: 'none',
//             textTransform: 'none',
//             fontSize: '30px',
//             padding: '6px 12px',
//             border: '1px solid',
//             lineHeight: 1.5,
//             backgroundColor: '#4CC3B6',
//             borderColor: '#4CC3B6',
//             minWidth: 400,
//             minHeight: 80,
//             '&:hover': { backgroundColor: '#4CC3B6' },
//           },
//         },
//         {
//           props: { variant: 'btn-accept' },
//           style: {
//             color: 'white',
//             boxShadow: 'none',
//             textTransform: 'none',
//             fontSize: '30px',
//             padding: '6px 12px',
//             border: '1px solid',
//             lineHeight: 1.5,
//             backgroundColor: '#ED1C24',
//             borderColor: '#ED1C24',
//             minWidth: 400,
//             minHeight: 80,
//             '&:hover': { backgroundColor: '#ED1C24' },
//           },
//         },
//         {
//           props: { variant: 'btn-totem-teclado' },
//           style: {
//             width: '97.5px',
//             height: '90px',
//             margin: '0 auto',
//             padding: 0,
//             paddingTop: '10px',
//             display: 'inline-block',
//             lineHeight: '50px',
//             marginTop: '9px',
//             textAlign: 'center',
//             color: 'white',
//             backgroundColor: '#5A5758',
//             fontSize: '50px',
//             borderRadius: '10px',
//             '&:hover': { backgroundColor: '#5A5758' },
//           },
//         },
//       ],
//     },
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           padding: 0,
//           margin: 0,
//           marginTop: '8px',
//           height: '90px',
//           '& .MuiInputBase-input': {
//             // borderRadius: '10px',
//             backgroundColor: 'red',
//             color: 'white',
//             fontSize: '40px',
//             lineHeight: '90px',
//             '-webkit-text-fill-color': 'white !important',
//             '&::placeholder': {
//               opacity: 1,
//             },
//           },
//         },
//       },
//     },
//   },
// };

export const createTheme = function createTheme(config) {
  let theme = createMuiTheme(
    baseThemeOptions,
    config.mode === 'dark' ? darkThemeOptions : lightThemeOptions,
    {
      direction: config.direction,
    },
    config.themeOverride || {},
    // debugTotemTheme,
    esES,
    pickersEsES
  );

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
